'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const tslib_es6 = require('../../../tslib.es6-CZ43up4V.js');
const jsxRuntime = require('react/jsx-runtime');
const zinniaIcons = require('@zapier/zinnia-icons');
const clsx = require('clsx');
const reactAriaComponents = require('react-aria-components');

const iconButton = "_icon-button_19jwl_1";
const styles = {
	iconButton: iconButton
};

const sizeMap = {
  small: 20,
  medium: 24,
  large: 32
};
const IconButton = (_a) => {
  var { className, isDisabled = false, name, children, size = "medium", style, variant = "primary" } = _a, props = tslib_es6.__rest(_a, ["className", "isDisabled", "name", "children", "size", "style", "variant"]);
  const getContent = (buttonRenderProps) => {
    if (name) {
      return jsxRuntime.jsx(zinniaIcons.Icon, { "aria-hidden": true, name, shouldAnimateFill: false, size: sizeMap[size] });
    }
    if (typeof children === "function") {
      return children(buttonRenderProps);
    }
    if (!children) {
      console.warn("IconButton should be passed a `name` or `children` prop.");
      return null;
    }
    return children;
  };
  return jsxRuntime.jsx(reactAriaComponents.Button, Object.assign({}, props, { className: (renderProps) => {
    const dynamicClassName = typeof className === "function" ? className(renderProps) : className;
    return clsx.clsx(dynamicClassName, styles.iconButton);
  }, "data-variant": variant, "data-size": size, "data-zds": true, isDisabled, style, children: getContent }));
};

exports.IconButton = IconButton;
//# sourceMappingURL=IconButton.cjs.js.map
